import { IDataInformation } from '../../../common/interfaces/dtos/IDataInformation';
import { IItemInputData } from '../../../common/interfaces/IItemInputData';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { AxiosRequestConfig } from 'axios';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';

export const dataAdd = async (
  transactionId: string | undefined,
  inputData: IItemInputData,
): Promise<IDataInformation> => {
  const axiosConfig: AxiosRequestConfig = {
    url: '/transaction-management/data-add-information',
    method: 'GET',
    params: {
      transactionId: transactionId,
      entryMethod: inputData.entryMethod,
      itemId: inputData.itemId,
      scanDataType: inputData.scanDataType,
    },
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };

  return emeraldRequest<IDataInformation>(emeraldRequestParams);
};
